import React from "react";
import { REWARD_OFFERING } from "../../constants";
import { getRedeemUrlWithContext } from "../../utils";
import OnboardingPage from "../../common/components/OnboardingPage";

function BookingDotComMain() {
  const redeemUrl = getRedeemUrlWithContext("booking-dot-com");

  return (
    <>
        <OnboardingPage
          redeemUrl={redeemUrl}
          rewardId={REWARD_OFFERING.bookingdotcom}
        />
    </>
  );
}

export default BookingDotComMain;